import { render, staticRenderFns } from "./carriers-tab.vue?vue&type=template&id=17affa0c"
import script from "./carriers-tab.vue?vue&type=script&lang=js"
export * from "./carriers-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports